"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteSectionPublicProvider = void 0;
var react_1 = __importStar(require("react"));
var Helpers_1 = require("@CommonFrontendBackend/Quote/Helpers");
var QuoteSectionContext_1 = require("@CommonFrontend/ContentTokens/SharedWidgetComponents/QuoteSection/QuoteSectionContext");
var useMobxEject_1 = require("@CommonFrontend/hooks/useMobxEject");
var QuoteSectionPublicProvider = function (_a) {
    var initialSection = _a.section, initialPrice = _a.price, di = _a.di, children = _a.children, id = _a.id;
    var _b = (0, useMobxEject_1.useMobxEject)(function () {
        var quoteSummaryStore = di === null || di === void 0 ? void 0 : di.get("quoteSummaryStore");
        if (!quoteSummaryStore)
            return { section: initialSection, price: initialPrice };
        return {
            section: __assign(__assign({}, initialSection), (0, Helpers_1.getQuoteSummaryForItem)(quoteSummaryStore.quoteSummary, "section", id)),
            price: (0, Helpers_1.getPriceSummaryTotalForItem)(quoteSummaryStore.priceSummary, id),
        };
    }, [di, id, initialPrice, initialSection]), section = _b.section, price = _b.price;
    var _c = __read((0, react_1.useState)(initialSection.display.collapsed), 2), collapsed = _c[0], setCollapsed = _c[1];
    var toggleSectionSelected = function () {
        var _a;
        (_a = di === null || di === void 0 ? void 0 : di.get("quoteSummaryStore")) === null || _a === void 0 ? void 0 : _a.toggleSectionSelected(id);
    };
    var toggleSectionCollapsed = function () {
        setCollapsed(!collapsed);
    };
    return (react_1.default.createElement(QuoteSectionContext_1.QuoteSectionProvider, { value: {
            components: {},
            section: __assign(__assign({}, section), { display: __assign(__assign({}, section.display), { collapsed: collapsed }) }),
            price: price,
            actions: {
                toggleSectionSelected: toggleSectionSelected,
                toggleSectionCollapsed: toggleSectionCollapsed,
                addSection: function () { return undefined; },
            },
        } }, children));
};
exports.QuoteSectionPublicProvider = QuoteSectionPublicProvider;
